import Vue from 'vue'
import Vuex from 'vuex'
import notifications from './modules/notifications'
import panel from './modules/panel'
import footer from './modules/footer'
import user from './modules/user'
import signupWizard from '@/modules/auth/store/signupWizard'
import fileStorage from '@/modules/documents/store/fileStorage'
import documents from '@/modules/documents/store/documents'
import fielStorage from '@/modules/signers/store/fielStorage'
import uploadWizardStore from '@/modules/documents/store/uploadWizardStore'
import notificationStore from '@/modules/documents/store/notificationStore'
import signersStore from '@/modules/signers/store/signersStore'
import signingWizardStore from '@/modules/signers/store/signingWizardStore'
import signingReviewStore from '@/modules/signers/store/signingReviewStore'
import viewerPDFStore from '@/modules/signers/store/viewerPDFStore'
import documentTypeStore from '@/modules/catalogs/store/documentTypeStore'
import folderStore from '@/modules/catalogs/store/folderStore'
import mainTheme from './modules/mainTheme'
import mainApp from './modules/mainApp'
import resource from './modules/resource'
import documentsStatistics from '@/modules/documents/store/documentsStatistics'
import documentsChartStore from '@/modules/dashboard/store/documentsChartStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    notifications,
    panel,
    footer,
    user,
    signupWizard,
    fileStorage,
    documents,
    mainTheme,
    fielStorage,
    uploadWizardStore,
    notificationStore,
    signersStore,
    signingWizardStore,
    signingReviewStore,
    viewerPDFStore,
    documentTypeStore,
    folderStore,
    mainApp,
    resource,
    documentsStatistics,
    documentsChartStore
  }
})
